import React from "react";

const EmptyState = ({ title, message }) => {
  return (
    <div className="empty-state">
      <div className="empty-title">{title}</div>
      <div className="empty-message">{message}</div>
    </div>
  );
};

export default EmptyState;
